export default __webpack_public_path__ + "static/media/shuffle.24d8bc70.png";